<template>
    <div
        class="flex h-full animate-pulse items-center justify-center bg-bigg-gray text-center font-medium leading-none duration-100"
    >
        {{ $t('common.loading') }}...
    </div>
</template>
